<section>
  <div class="container-fluid my-1 p-0 mx-auto">
    <div class="col-xl-11 col-lg-11 col-md-11 col-11 justify-content-center py-1 mx-auto">
      <form [formGroup]="form">
        <div class="col-md-12">
          <div class="mb-0">
            <div class="section-title-02 mb-2 text-center">
              <h4>Prepare Proposal</h4>
            </div>
            <div class="cover-photo-contact">
              Please upload voice reels and demos only and any other document to support your application. Do not attach your résumé profile is automatically available to the client with your proposal.
              <div class="upload-file">
                <div class="custom-file">
                  <app-upload [title]="'Upload attachment'" [acceptedFiles]="'.pdf,.m4v,.avi,.mpg,.mp4'"
                    (onUploadFinished)="uploadFinished($event)"></app-upload>
                </div>
                {{fileName}}
                {{uploadStatus}}
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label>Rate($)*</label>
                <div class=" row">
                  <div class="col-md-6 float-left">
                    <input type="text" class="form-control salary-input" formControlName="rate" type="number" min="0"
                      placeholder="Enter rate"
                      [class.is-invalid]="(form.controls['rate']?.errors || form.controls['rate']?.errors?.required)">
                  </div>

                  <div class="col-md-6 float-left">
                    <select class="form-control basic-select" formControlName="salaryType"
                      [class.is-invalid]="(form.controls['salaryType']?.errors || form.controls['salaryType']?.errors?.required)">
                      <option value="" disabled selected>Select rate type</option>
                      <option *ngFor="let salaryType of lookupStore.salaryTypes | async" [ngValue]="salaryType.id">
                        {{salaryType.value}}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="form-group mb-0 col-md-12">
                <label>Cover letter*</label>
                <textarea class="form-control" rows="15" formControlName="coverLetter"
                  [class.is-invalid]="(form.controls['coverLetter']?.errors || form.controls['coverLetter']?.errors?.required)"
                  placeholder="Please give a brief description of your skills and experiences."></textarea>
              </div>
            </div>
            <div class="mb-1 mt-4">
              <button class="btn btn-primary save-btn" (click)="sendProposal()" [disabled]="!form.valid">Send</button>
              <div *ngIf="!form.valid" class="form-validation-msg text-danger">Please fill in all the required
                fields(*).</div>
            </div>

          </div>

        </div>
      </form>
    </div>
  </div>
</section>